import $             from 'jquery';
import template      from './template.hbs';
import FormStep      from '../../classes/form-step';
import extend        from '../../util/extend';
import mask          from '../../util/phone-mask';
import validateEmail from '../../util/email';

export default new FormStep({
  $el: $('<form class="form-step step-contact" action="canvas" />'),
  template,
  events: {
    'render': 'afterRender',
    'submit-clicked': 'track'
  },
  render( state ) {

    if ( window.preloaded_address ) {
      // need the state as a nested object for immediate use in template,
      // and also needed it in the way the state expects it ( 'address.line1' )
      // in order to dispatch and update to store it
      const address = {};
      const formattedForState = {};

      Object.keys( window.preloaded_address ).forEach( item => {
        const val = window.preloaded_address[ item ];
        formattedForState[ `address.${ item }` ] = val;
        address[ item ] = val;
      });

      this.dispatch({ type: 'change', data: formattedForState });
      state = extend( {}, state, { address } );
      delete window.preloaded_address;
    }

    if ( window.place_raw ) {
      state = extend( {}, state, { place: window.place_raw } );
    }

    return FormStep.prototype.render.call( this, state );
  },
  afterRender() {
    const input = this.$el.find('#address-phone')[ 0 ];
    mask( input );
  },
  rules: {
    first_name: /\S+/,
    'address.line2': /\S+/,
    last_name: /\S+/,
    email: validateEmail,
    // eslint-disable-next-line max-len
    phone: /^([0-1]([\s-./\\])?)?(\(?[2-9]\d{2}\)?|[2-9]\d{3})([\s-./\\])?(\d{3}([\s-./\\])?\d{4}|[a-zA-Z0-9]{7})$/
  },
  track({ address = {}, email, first_name, last_name, phone }) {
    if ( window.acumen ) {
      let addressname = null;
      const { line1, city, state, zip } = address;

      if ( line1 && city && state && zip ) {
        addressname = `${ line1 }, ${ city }, ${ state }, ${ zip }`;
      }

      window.acumen.track( 'web-submit-contact', {
        email: email || null,
        first_name: first_name || null,
        last_name: last_name || null,
        phone: phone || null,
        address: addressname,
        unit: address.line2 || null
      });

      if ( email ) {
        window.acumen.identify({ email });
      }
    }
  }
});
